module.exports = __webpack_public_path__ + "static/media/Feature002.0ef4d71d.png";